class SolutionsController {
    constructor() {
        this.name = 'solutions';
    }

    goCoop() {
        window.open('/cooperation')
    }
}

export default SolutionsController;



// WEBPACK FOOTER //
// ./src/app/components/face/solutions/solutions.controller.js